import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core'
import {Router} from '@angular/router'
import {IonicModule, IonModal} from '@ionic/angular'
import {TranslateConfigService} from 'src/app/services/translate-config.service'
import {UtilsService} from 'src/app/services/utils/utils.service'
import {CommonModule} from '@angular/common'
import {TranslateModule} from '@ngx-translate/core'

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class DialogComponent implements OnInit {
  @Input() show!: boolean
  @Input() type: string = 'clear'
  @Input() buttonText: string = 'DIALOG.UNDERSTOOD'
  @Input() cssClass: string | string[] | undefined
  @Input() close: boolean = false
  @Input() acceptDisabled: boolean = false
  @Output() toggle: EventEmitter<void> = new EventEmitter<void>()
  @Output() confirm: EventEmitter<void> = new EventEmitter<void>()
  @Input() transparent: boolean = false
  @Input() stripeDisclaimer: boolean = false
  isWeb: boolean = false
  @ViewChild(IonModal) modal!: IonModal
  /**
   * Flag to indicate the dismissal was initiated by one of our own buttons
   * (close / cancel / confirm). It remains true until the IonModal actually
   * finishes dismissing (ionModalDidDismiss), preventing a second spurious
   * (toggle) emission that would re-toggle the parent state.
   */
  private manualClosing = false;

  toggleShow() {
    if (!this.show) return; // already closed
    this.manualClosing = true;
    this.toggle.emit(); // parent will set show=false -> modal dismiss starts
  }

  confirmAction() {
    if (!this.show) return;
    this.manualClosing = true;
    // Emit confirm first so parent can handle the confirmation action immediately.
    // Then request the parent to close the modal. Keep manualClosing true until
    // onDidDismiss fires to avoid duplicate toggles.
    this.confirm.emit();
    setTimeout(() => {
      this.toggle.emit();
    }, 20);
  }

  onDidDismiss() {
    // Backdrop / ESC dismissal (no manualClosing) -> request parent to toggle off
    if (!this.manualClosing) {
      this.toggle.emit();
    }
    // Reset flag AFTER handling dismissal so future opens work normally
    this.manualClosing = false;
  }

  onBackdropTap() {
    // Called when user taps the backdrop. If we're not in a manual closing flow,
    // request the parent to toggle off. On some iOS versions backdropDismiss
    // may not trigger ionModalDidDismiss reliably, so handle it here.
    if (!this.show) return;
    if (!this.manualClosing) {
      // Mark as manual closing so ionModalDidDismiss won't emit a second toggle
      // which would cause the parent to toggle the show state twice and reopen
      // the dialog immediately after it closed.
      this.manualClosing = true;
      this.toggle.emit();
    }
  }

  constructor(private router: Router, private utilsService: UtilsService, private translateConfigService: TranslateConfigService) {
  }

  async ngOnInit() {
    this.isWeb = await this.utilsService.detectIsWeb()
  }

  navigate(path: string) {
    this.toggleShow()
    setTimeout(() => {
      this.router.navigate([path])
    }, 100)
  }
}
